import _ from 'lodash'

import { hasAsteriskFromRiders } from 'core/service/rider/benefits/benefit-data'
import { renderBIAge } from 'core/service/insured/age'
import { formatNumber } from 'core/service/lib/number-format'
import SummaryTable from './summary-table'
import MESSAGES from 'core/data-model/constants/messages'
import BIMESSAGES from 'core/data-model/constants/bi-messages'

const renderCoveragePeriod = (displayProduct, calculatedCoveragePeriod) => {
  if (displayProduct?.basicPlanCode === 'W80F06') {
    return BIMESSAGES.COVERAGE_PERIOD_ISMART_SUFFIX
  }
  return `${calculatedCoveragePeriod} ${MESSAGES.TIME_UNIT_YEAR}`
}

const ProfileSnapshot = ({
  displayProduct,
  riders,
  genderLabel,
  age,
  calculatedCoveragePeriod,
  calculatedPaymentPeriod,
  policyValue,
  sumAssured,
  basicPremium,
  totalPremium,
  selectedModelFactorLabel,
  hasNonLevelRider,
  hasShowDisclaimerRiderAsterisk,
  totalRiderPremium,
  profileSummaryHeader,
  summaryTableHeader,
  showGraph = true,
  selectedModelFactorID,
  isNewAsteriskOfSummaryMainContract,
  isReviseQQ,
  isCheckHaveRiderCampaignDiscountActive,
  riderCampaignDiscountBIMessage,
}) => {
  return (
    <div id="profile-summary" className="snapshot group">
      <h2>
        {_.isFunction(profileSummaryHeader)
          ? // $$FlowFixMe
            profileSummaryHeader({
              displayProduct,
              riders,
              genderLabel,
              age,
              calculatedCoveragePeriod,
              calculatedPaymentPeriod,
              sumAssured,
              basicPremium,
              totalPremium,
              selectedModelFactorLabel,
              hasNonLevelRider,
              totalRiderPremium,
            })
          : profileSummaryHeader}
      </h2>
      <div className="profile">
        <div className="info gender">
          <p className="label">{MESSAGES.GENDER}</p>
          <p className="value">{genderLabel}</p>
        </div>
        <div className="info age">
          <p className="label">{MESSAGES.AGE}</p>
          <p className="value">{renderBIAge(age, isReviseQQ)}</p>
        </div>
        <div className="info coverage-period">
          <p className="label">{BIMESSAGES.COVERAGE_PERIOD}</p>
          <p className="value">{renderCoveragePeriod(displayProduct, calculatedCoveragePeriod)}</p>
        </div>
        <div className="info payment-period">
          <p className="label">{BIMESSAGES.PAYMENT_PERIOD}</p>
          <p className="value">
            {selectedModelFactorID === 'model-factor_5'
              ? selectedModelFactorLabel
              : calculatedPaymentPeriod + ' ' + MESSAGES.TIME_UNIT_YEAR}
          </p>
        </div>
      </div>
      <div className="coverage">
        <div className="info sum-assured">
          <p className="label">{BIMESSAGES.BASIC_PLAN_SUM_ASSURED}</p>
          <p className="value">
            {formatNumber(sumAssured)} {MESSAGES.BAHT}
          </p>
        </div>
        <div className="info model-factor">
          <p className="label">{MESSAGES.PAYMENT_MODE}</p>
          <p className="value">{selectedModelFactorLabel}</p>
        </div>
      </div>
      <div className="coverage">
        <div className="info basic-premium">
          <p className="label">{BIMESSAGES.BASIC_PREMIUM}</p>
          <p className="value">
            {formatNumber(basicPremium, 2)} {MESSAGES.BAHT}
          </p>
        </div>
        <div className="info rider-premium">
          <p className="label">
            {BIMESSAGES.TOTAL_RIDER_PREMIUM}
            {hasAsteriskFromRiders(riders) ? '*' : ''}
          </p>
          <p className="value">
            {formatNumber(totalRiderPremium, 2)} {MESSAGES.BAHT}
            {/*{totalRiderPremium(riders)}*/}
          </p>
        </div>
        <div className="info total-premium">
          <p className="label">{BIMESSAGES.TOTAL_PREMIUM_FIRST_PREMIUM}</p>
          <p className="value">
            {formatNumber(totalPremium, 2)} {MESSAGES.BAHT}
          </p>
        </div>
        {isCheckHaveRiderCampaignDiscountActive && riderCampaignDiscountBIMessage.length > 0
          ? riderCampaignDiscountBIMessage.map((riderMsg, index) => {
              return (
                <div key={index} className="rider-campaign-discount-message">
                  {riderMsg}
                </div>
              )
            })
          : ''}
      </div>
      <SummaryTable
        displayProduct={displayProduct}
        riders={riders}
        age={age}
        calculatedCoveragePeriod={calculatedCoveragePeriod}
        calculatedPaymentPeriod={calculatedPaymentPeriod}
        basicPremium={basicPremium}
        totalPremium={totalPremium}
        basicSumAssured={sumAssured}
        hasNonLevelRider={hasNonLevelRider}
        hasShowDisclaimerRiderAsterisk={hasShowDisclaimerRiderAsterisk}
        selectedModelFactorID={selectedModelFactorID}
        selectedModelFactorLabel={selectedModelFactorLabel}
        summaryTableHeader={summaryTableHeader}
        isNewAsteriskOfSummaryMainContract={isNewAsteriskOfSummaryMainContract}
      />
    </div>
  )
}

export default ProfileSnapshot
